import React from 'react'
import { EventCategoriesService } from '../../../../service'
import { Page } from '../../../Page'
import { SidebarLinks } from '../../links'
import { ListNamedEntitiesPage } from '../common/ListPage'
import { SettingsLinks } from '../links'

const breadcrumbs = [
  { path: SidebarLinks.Index, name: 'Dashboard' },
  { path: SidebarLinks.Settings, name: 'Settings' },
  {
    path: '',
    name: 'Event Categories',
  },
]

const View = () => (
  <ListNamedEntitiesPage
    breadcrumbs={breadcrumbs}
    service={EventCategoriesService}
    singular="Event Category"
    plural="Event Categories"
    listLink={SettingsLinks.EventCategories}
    createLink={SettingsLinks.CreateEventCategory}
  />
)

export const EventCategories = Page(View, 'Event Categories')
